import { useRouteLoaderData } from '@remix-run/react';

import type { RootLoaderData } from '~/root';
import type { loader as communityLoader } from '~/routes/community';

export const useCommunityLogoUrl = (): string | undefined => {
  const layoutData = useRouteLoaderData<typeof communityLoader>('routes/community');
  const rootData = useRouteLoaderData<RootLoaderData>('root');

  return layoutData?.community?.logo_url ?? rootData?.site?.publication?.logo?.thumb?.url;
};
